import Box from "@mui/material/Box";
import React, {useEffect, useState} from "react";
import {Tooltip} from "@mui/material"


export default function TeamIcon(props: {team_name: string, sx? :any}){
    const size = props.sx?.width || props.sx?.height || 40;
    const [src, setSrc] = useState(
        `https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${size},w_${size}/teamsLogo/${props.team_name?.split('_')[0]}.png`
    );

    const handleImageError = () => {
        setSrc(`https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${size},w_${size}/teamsLogo/Please Dont Fire.png`);
    };

    useEffect(() => {
        setSrc(`https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${size},w_${size}/teamsLogo/${props.team_name?.split('_')[0]}.png`);
    }, [props.team_name, size]);

    return <Tooltip title={props.team_name} followCursor={true}>
        <Box
            component={"img"}
            src={src}
            onError={() => handleImageError()}
            sx={{
                width: size,
                height: size,
                minWidth: size,
                minHeight: size,
                ...props.sx
            }}
        />
    </Tooltip>
}
